import { __decorate } from "tslib";
import { Component, Vue, Prop, Ref, Watch } from 'vue-property-decorator';
import debounce from 'lodash/debounce';
import { get, isEmpty } from 'lodash';
import ImageUtil from '@blade/common/utils/image-util';
import hotMap from '@blade-sxp/monitor/pages/main/record-center/components/task/hotmap.vue';
const Colors = {
    Arrow: '#FF0000',
    Head: 'red',
    Line: 'red',
    BackGound: 'rgba(247, 181, 0, 0.5)'
};
let default_1 = class default_1 extends Vue {
    item;
    shouldDrawArrow;
    shouldDrawLine;
    showMap;
    viewMap;
    showBackground;
    canvas;
    image;
    bgImageUrl;
    crowdData;
    scale = 1;
    imageShow = false;
    size = { width: 0, height: 0 };
    sizeChangeFun;
    created() {
        const { crowdSubGroups, panoramicImage } = this.item || {};
        this.crowdData = crowdSubGroups;
        this.bgImageUrl = panoramicImage;
    }
    mounted() {
        this.sizeChangeFun = debounce(() => {
            this.onSizeChange();
        }, 100);
        window.addEventListener('resize', this.sizeChangeFun);
    }
    get mapList() {
        return JSON.parse(this.item.densityMap);
    }
    toggleBackGround() {
        this.drawCrowd();
    }
    setSize({ size, naturalSize }) {
        this.size = size;
        this.scale = size.width / naturalSize.width;
    }
    imageOnload() {
        this.imageShow = true;
        const [naturalSize, size] = this.getSize();
        this.setSize({ size, naturalSize });
        this.drawCrowd();
    }
    getSize() {
        const imageDom = this.image;
        if (!imageDom)
            return [this.size, this.size];
        const naturalSize = { width: imageDom.naturalWidth, height: imageDom.naturalHeight };
        const size = { width: Math.round(imageDom.width), height: Math.round(imageDom.height) };
        return [naturalSize, size];
    }
    drawCrowd(canvasEle, canvasSize) {
        const canvas = canvasEle || this.canvas;
        const size = canvasSize || this.size;
        canvas.width = size.width;
        canvas.height = size.height;
        const ctx = canvas.getContext('2d');
        if (!ctx) {
            console.warn('canvas.getContext failed');
            return;
        }
        // ctx.clearRect(0, 0, size.width, size.height); TODO ???
        if (this.showBackground !== false) {
            this.drawArea(ctx);
        }
        this.crowdData.forEach((item) => {
            const personInfos = item.personInfos || [];
            if (this.shouldDrawLine) {
                this.drawLine(ctx, personInfos);
            }
            for (let i = 0, length = personInfos.length; i < length; i++) {
                this.drawRoi(personInfos[i], ctx);
            }
        });
        if (this.shouldDrawArrow) {
            this.drawLineArrow(ctx, size);
        }
        // ctx.closePath();
    }
    drawLineArrow(cxt, canvasSize) {
        const directions = get(JSON.parse(this.item.taskConfig), 'directions', []);
        if (!directions) {
            return;
        }
        const { width, height } = canvasSize;
        let fromX = directions[0].x * width;
        let fromY = directions[0].y * height;
        let toX = directions[1].x * width;
        let toY = directions[1].y * height;
        const ArrowLength = 10; // 自定义箭头线的长度
        const theta = 45 * Math.PI / 180; // 自定义箭头线与直线的夹角，个人觉得45°刚刚好
        let arrowX, arrowY; // 箭头线终点坐标
        // 计算各角度和对应的箭头终点坐标
        const angle = Math.atan2(fromY - toY, fromX - toX);
        const angle1 = angle + theta;
        const angle2 = angle - theta;
        const topX = ArrowLength * Math.cos(angle1);
        const topY = ArrowLength * Math.sin(angle1);
        const botX = ArrowLength * Math.cos(angle2);
        const botY = ArrowLength * Math.sin(angle2);
        cxt.beginPath();
        cxt.lineWidth = 3;
        // 画直线
        cxt.moveTo(fromX, fromY);
        cxt.lineTo(toX, toY);
        arrowX = toX + topX;
        arrowY = toY + topY;
        // 画上边箭头线
        cxt.moveTo(arrowX, arrowY);
        cxt.lineTo(toX, toY);
        arrowX = toX + botX;
        arrowY = toY + botY;
        // 画下边箭头线
        cxt.lineTo(arrowX, arrowY);
        cxt.strokeStyle = Colors.Arrow;
        cxt.stroke();
    }
    drawLine(cxt, personInfos) {
        let fromX = personInfos[0].coordinate.x * this.scale;
        let fromY = personInfos[0].coordinate.y * this.scale;
        let toX = personInfos[1].coordinate.x * this.scale;
        let toY = personInfos[1].coordinate.y * this.scale;
        cxt.beginPath();
        cxt.lineWidth = 2;
        cxt.strokeStyle = Colors.Line;
        cxt.moveTo(fromX, fromY);
        cxt.lineTo(toX, toY);
        cxt.stroke();
    }
    drawRoi(personInfo, ctx) {
        const { rectangle: { vertices } } = personInfo;
        const fromX = vertices[0].x;
        const fromY = vertices[0].y;
        const toX = vertices[1].x;
        const toY = vertices[1].y;
        this.drawRect(ctx, fromX, fromY, toX, toY);
    }
    drawRect(ctx, fromX, fromY, toX, toY) {
        ctx.beginPath();
        ctx.lineWidth = 2;
        ctx.strokeStyle = Colors.Head;
        const width = Math.abs(toX - fromX) * this.scale;
        const height = Math.abs(toY - fromY) * this.scale;
        ctx.strokeRect(fromX * this.scale, fromY * this.scale, width, height);
    }
    drawArea(ctx) {
        const vertices = get(JSON.parse(this.item.taskConfig), 'roi.vertices', []);
        if (isEmpty(vertices)) {
            return;
        }
        const itema = vertices.map((k) => {
            return {
                x: k.x * this.size.width,
                y: k.y * this.size.height,
            };
        });
        ctx.beginPath();
        ctx.lineWidth = 1;
        ctx.strokeStyle = '#F7B500';
        ctx.moveTo(itema[0].x, itema[0].y);
        for (var i = 1; i < itema.length; i++) {
            ctx.lineTo(itema[i].x, itema[i].y);
        }
        ctx.fillStyle = Colors.BackGound;
        ctx.closePath();
        ctx.stroke();
        ctx.fill();
    }
    onSizeChange() {
        // TODO when
        const [naturalSize, size] = this.getSize();
        // 尺寸没变，不作处理
        if (size.width !== this.size.width) {
            this.setSize({ size, naturalSize });
            this.drawCrowd();
        }
    }
    /**
     *
     * 合成ROI和图片
     *
     */
    async composite() {
        const [naturalSize] = this.getSize();
        // 创建临时画布
        const canvas = document.createElement('canvas');
        // 在临时画布上基于原图大小画ROI
        this.drawCrowd(canvas, naturalSize);
        const roiDataUrl = canvas.toDataURL();
        canvas.width = naturalSize.width;
        canvas.height = naturalSize.height;
        const ctx = canvas.getContext('2d');
        if (ctx)
            ctx.clearRect(0, 0, naturalSize.width, naturalSize.height);
        await ImageUtil.compositeImage([this.bgImageUrl, roiDataUrl], canvas); // TODO 热力图合成
        return canvas.toDataURL();
    }
};
__decorate([
    Prop()
], default_1.prototype, "item", void 0);
__decorate([
    Prop()
], default_1.prototype, "shouldDrawArrow", void 0);
__decorate([
    Prop()
], default_1.prototype, "shouldDrawLine", void 0);
__decorate([
    Prop()
], default_1.prototype, "showMap", void 0);
__decorate([
    Prop()
], default_1.prototype, "viewMap", void 0);
__decorate([
    Prop()
], default_1.prototype, "showBackground", void 0);
__decorate([
    Ref()
], default_1.prototype, "canvas", void 0);
__decorate([
    Ref()
], default_1.prototype, "image", void 0);
__decorate([
    Watch('showBackground'),
    Watch('shouldDrawArrow')
], default_1.prototype, "toggleBackGround", null);
default_1 = __decorate([
    Component({
        name: 'CrowdRoi',
        components: { hotMap }
    })
], default_1);
export default default_1;
